import { Link } from '@mui/material'
import React from 'react'
import './TermsAndConditions.css'

const TermsAndConditions = () => {
  return (
    <div>
      <h1 className='text-center terms-condition-title'><Link className='terms-condition-title-link'>Batak Pro Game Rules and Regulations</Link></h1>
      <div><br/>
      <Link className='terms-condition-title-link'> <h2 className='terms-condition-sub-title'>Eligibility</h2></Link>
        <ul>
          <li>Participants must be at least 18 years old age.</li>
          <li>The game is accessible to all visitors at the Kama Capital booth during the expo.</li>
        </ul>
      </div>
      <div>
      <Link className='terms-condition-title-link'> <h2 className='terms-condition-sub-title'>Game Mechanics</h2></Link>
        <ul>
          <li>Participants must stand in the designated area to play the Batak Pro game. This game tests reaction speed by requiring players to press buttons that light up on the game panel.</li>
          <li>The leaderboard will record the number of buttons pressed by each participant within the allotted time, as indicated on the ‘Batak Pro’ panel only.</li>
          <li>Participants must attain a minimum score to qualify for a giveaway.</li>
        </ul>
      </div>
      <div>
      <Link className='terms-condition-title-link'> <h2 className='terms-condition-sub-title'>Tie-Breaker Rule</h2> </Link>
        <p>If several participants attain the same score, the subsequent tie-breaker rule will be applied:</p>
        <ul>
          <li>The participant who registered first will be ranked higher on the leaderboard.</li>
          <li>This rule will remain in effect until the top five participants are determined.</li>
        </ul>
      </div>
      <div>
      <Link className='terms-condition-title-link'> <h2 className='terms-condition-sub-title'>Giveaways</h2> </Link>
       
        <ul>
          <li>The top five names on the leaderboard will receive a giveaway based on the score.</li>
          <li>Giveaways are non-transferable and cannot be exchanged for cash or other prizes.</li>
          <li>Winners must be at the booth to collect their prizes on the same day before the expo doors close.</li>
          <li>Representatives are not permitted to collect prizes on behalf of the winners.</li>
        </ul>
      </div>
      <div>
      <Link className='terms-condition-title-link'> <h2 className='terms-condition-sub-title'>Participation</h2></Link>
       
        <ul>
          <li>Each participant is permitted only one attempt per day.</li>
          <li>Participants should register at the booth before playing the game.</li>
          <li>By participating, participants consent to sharing their photographs and other details on Kama Capital’s social media and other digital platforms.</li>
          <li>Participants also consent to be contacted by a company representative for promotional purposes.</li>
        </ul>
      </div>
      <div>
      <Link className='terms-condition-title-link'> <h2 className='terms-condition-sub-title'>Safety Guidelines</h2></Link>
        <ul>
          <li>Participants should adhere to the instructions given by the game supervisor.</li>
          <li>The game area should remain clear of obstacles.</li>
          <li>Any participant who does not adhere to the safety guidelines will be disqualified.</li>
        </ul>
      </div>

      <div>
      <Link className='terms-condition-title-link'> <h2 className='terms-condition-sub-title'>Disqualification</h2> </Link>
        <p>Participants will be disqualified for:</p>
        <ul>
          <li>Not keeping up with the game rules.</li>
          <li>Attempting to press buttons before or after the timer begins or ends.</li>
          <li>Participating in disruptive behaviour.</li>
        </ul>
      </div>

      <div>
      <Link className='terms-condition-title-link'> <h2 className='terms-condition-sub-title'>Liability</h2> </Link>
        <ul>
          <li>Kama Capital accepts no responsibility for any injuries sustained during participation in the game.</li>
          <li>By participating, participants agree to release Kama Capital from any liability related to the game.</li>
        </ul>
      </div>

      <div>
      <Link className='terms-condition-title-link'> <h2 className='terms-condition-sub-title'>Terms & Conditions</h2> </Link>
        <ul>
          <li>Participants accept all rules and regulations by participating in the Batak Pro game.</li>
          <li>Kama Capital reserves the right to modify the rules or cancel the game at any time without prior notice.</li>
          <li>Any disputes will be resolved at the discretion of the Kama Capital team.</li>
        </ul>
      </div>

      <div>
      <Link className='terms-condition-title-link'> <h2 className='terms-condition-sub-title'>Privacy</h2> </Link>
        <ul>
          <li>Participant data gathered during registration will be utilised exclusively for the game and any follow-up communications.</li>
          <li>By participating, participants consent to the collection and use of their personal information as detailed in Kama Capital’s privacy policy.</li>
        </ul>
      </div>
    </div>
  )
}

export default TermsAndConditions
